import React, { useMemo } from 'react';
import { TableContainer } from '@this/shared/ui/data_displays/table';

type Props = { title: string; renderHeaderAction?: React.ReactNode; renderTable: React.ReactNode };

export const BulkTicketsSection = ({ title, renderHeaderAction, renderTable }: Props) => {
  const styles = useMemo(() => getStyles(), []);
  return (
    <section>
      <header style={styles.header}>
        <h2 style={styles.title}>{title}</h2>
        {renderHeaderAction && <div>{renderHeaderAction}</div>}
      </header>

      <TableContainer height="calc(100vh - 350px)">{renderTable}</TableContainer>
    </section>
  );
};

const getStyles = () => ({
  header: {
    display: 'flex' as const,
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between' as const,
    height: 32
  },
  title: {
    margin: 0
  }
});
